// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3dcba","col":"styles_col__WMjpN"};